import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import { containerStyle } from 'src/styles/containerStyle';
import { Box } from 'native-base';

import MlStackTabs from 'src/components/ml/MlStackTabs';
import { IStore } from '../../../redux/reducers';

export default function MlDashboardPage({ navigation, route }) {
    const dispatch = useDispatch();
    const currentDatasetId = useSelector((store: IStore) => store.dataset.datasetID);

    // Update URL when datasetId changes in Redux (e.g., when new dataset is selected)
    useEffect(() => {
        const datasetIdFromRoute = route?.params?.datasetId;
        if (currentDatasetId && currentDatasetId !== datasetIdFromRoute) {
            navigation.dispatch(
                CommonActions.setParams({
                    datasetId: currentDatasetId
                })
            );
        }
    }, [currentDatasetId, route?.params?.datasetId, navigation]);

    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <MlStackTabs navigation={navigation} route={route} />
        </Box>
    );
}